module.exports = __webpack_public_path__ + "static/media/background-image-home.e5ff871d.jpg";